import styled from 'styled-components';
import theme from '@/styles/theme';

export interface TextComponentProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  fontSize?: number;
  color?: string;
  fontWeight?: string | number;
}

const TextComponent = styled.div<TextComponentProps>`
  ${({ fontSize = 18, color = theme.DF_COLOR.BLACK, fontWeight = 500 }) => `
    font-size: ${fontSize}px;
    color: ${color};
    font-weight: ${fontWeight};
  `}
  white-space: pre-line;
`;

export default TextComponent;
